<template>
    <div class="container-fluid">
        <Breadcrumb title="SMTP Campaigns" button-url="smtpCampaignCreate"></Breadcrumb>

        <div class="row position-relative">
            <div class="col-12 row-preloader" v-if="(loadingNotFinished || loadingFinished)">
                <Preloader v-bind:class="{preloader: (loadingNotFinished || loadingFinished)}"></Preloader>
            </div>
            <div class="col-12" v-else>
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group mb-0">
                            <div class="form-group" v-if="isAdmin">
                                <treeselect placeholder="Search by owner"
                                            v-model="userSearch"
                                            :options="userSelect"
                                            :load-options="loadUsers"
                                            :auto-load-root-options="false"/>
                            </div>
                            <div class="input-group form-group">
                                <input v-model="campaignSearch.emailListName" type="text" class="form-control form-control-line"
                                   placeholder="Search by email list name">
                            </div>
                            <input v-model="campaignSearch.campaignName" type="text" class="form-control form-control-line"
                                   placeholder="Search by campaign name">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <h4 class="mb-3">Not finished campaigns:</h4>
                        <div v-if="campaignsNotFinished.length === 0">There are no Campaigns</div>
                        <div v-else>
                            <div class="table-responsive">
                                <table class="table table-sm">
                                    <thead>
                                    <tr class="bg-info text-white">
                                        <th>ID</th>
                                        <th>Status</th>
                                        <th>Name</th>
                                        <th>Email List</th>
                                        <th>Message</th>
                                        <th>Offer</th>
                                        <th>Relay Status</th>
                                        <th>Relay Group</th>
                                        <th>Start Date</th>
                                        <th v-if="$store.getters.isAdmin">Owner</th>
                                        <th>Actions</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(campaign, index) in campaignsNotFinished" :key="index">
                                        <td class="align-middle">{{campaign.id}}</td>
                                        <td class="align-middle">
                                                <span class="label"
                                                      v-bind:class="[CampaignStatus.label[campaign.status]]">
                                                    {{CampaignStatus.value[campaign.status]}}
                                                    <span v-if="campaign.status === CampaignStatus.STATUS_ACTIVE">{{campaign.completion + '%'}}</span>
                                                </span>
                                        </td>
                                        <td class="align-middle">{{campaign.name}}</td>
                                        <td class="align-middle">{{campaign.emailListName}}</td>
                                        <td class="align-middle">
                                                <span class="campaign-message"
                                                      @click="openMessage(campaign.messageId, campaign.id)">
                                                    {{campaign.messageName}}
                                                </span>
                                        </td>
                                        <td class="align-middle">{{campaign.offerName}}</td>
                                        <td class="align-middle">{{RelayStatus.value[campaign.relayStatus]}}</td>
                                        <td class="align-middle">{{campaign.relayGroupName}}</td>
                                        <td class="align-middle">
                                            {{campaign.startDate ? campaign.startDate : "-"}}
                                        </td>
                                        <td class="align-middle" v-if="$store.getters.isAdmin">
                                            {{campaign.userName}}
                                        </td>
                                        <td class="align-middle">
                                            <router-link :to="{ name: 'smtpCampaignEdit', params: { id: campaign.id }}"
                                                         v-show="campaign.status === CampaignStatus.STATUS_INACTIVE"
                                                         class="btn btn-info m-r-10">
                                                <i v-tooltip.top="'Edit'" class="fa fa-edit"></i>
                                            </router-link>
                                            <router-link
                                                    :to="{ name: 'smtpCampaignStatistics', params: { id: campaign.id }}"
                                                    class="btn btn-primary m-r-10">
                                                <i v-tooltip.top="'Statistics'" class="fa fa-chart-line"></i>
                                            </router-link>
                                            <button type="button" class="btn btn-success m-r-10"
                                                    @click="startCampaign(campaign.id)"
                                                    v-show="startCampaignStatus(campaign)">
                                                <i class="fa fa-play-circle"></i>
                                            </button>
                                            <button type="button" class="btn btn-warning m-r-10"
                                                    @click="pauseCampaign(campaign.id)"
                                                    v-show="pauseCampaignStatus(campaign)">
                                                <i class="fa fa-pause-circle"></i>
                                            </button>
                                            <button type="button" class="btn btn-danger m-r-10"
                                                    @click="stopCampaign(campaign.id)"
                                                    v-show="stopCampaignStatus(campaign)">
                                                <i class="fa fa-stop-circle"></i>
                                            </button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <paginate v-if="pageCountNotFinished > 1"
                                      v-model="pageNotFinished"
                                      :page-count="pageCountNotFinished"
                                      :page-range="3"
                                      :margin-pages="2"
                                      :click-handler="getNotFinishedItems"
                                      :prev-text="'Prev'"
                                      :next-text="'Next'"
                                      :container-class="'mt-2 pagination justify-content-center'"
                                      :page-class="'page-item'"
                                      :page-link-class="'page-link'"
                                      :prev-class="'page-item'"
                                      :prev-link-class="'page-link'"
                                      :next-class="'page-item'"
                                      :next-link-class="'page-link'">
                            </paginate>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <h4 class="mb-3">Finished campaigns:</h4>
                        <div v-if="campaignsFinished.length === 0">There are no Campaigns</div>
                        <div v-else>
                            <div class="table-responsive">
                                <table class="table table-sm">
                                    <thead>
                                    <tr class="bg-info text-white">
                                        <th>ID</th>
                                        <th>Status</th>
                                        <th>Name</th>
                                        <th>Email List</th>
                                        <th>Message</th>
                                        <th>Offer</th>
                                        <th>Relay Status</th>
                                        <th>Relay Group</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th v-if="$store.getters.isAdmin">Owner</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(campaign, index) in campaignsFinished" :key="index">
                                        <td class="align-middle">{{campaign.id}}</td>
                                        <td class="align-middle">
                                                <span class="label"
                                                      v-bind:class="[CampaignStatus.label[campaign.status]]">
                                                    {{CampaignStatus.value[campaign.status]}}
                                                </span>
                                        </td>
                                        <td class="align-middle">
                                            <router-link :to="{ name: 'smtpCampaignStatistics', params: { id: campaign.id }}">
                                                {{campaign.name}}
                                            </router-link>
                                        </td>
                                        <td class="align-middle">{{campaign.emailListName}}</td>
                                        <td class="align-middle">
                                                <span class="campaign-message"
                                                      @click="openMessage(campaign.messageId, campaign.id)">
                                                    {{campaign.messageName}}
                                                </span>
                                        </td>
                                        <td class="align-middle">{{campaign.offerName}}</td>
                                        <td class="align-middle">{{RelayStatus.value[campaign.relayStatus]}}</td>
                                        <td class="align-middle">{{campaign.relayGroupName}}</td>
                                        <td class="align-middle">
                                            {{campaign.startDate ? campaign.startDate : "-"}}
                                        </td>
                                        <td class="align-middle">
                                            {{campaign.endDate ? campaign.endDate : "-"}}
                                        </td>
                                        <td class="align-middle" v-if="$store.getters.isAdmin">
                                            {{campaign.userName}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <paginate v-if="pageCountFinished > 1"
                                      v-model="pageFinished"
                                      :page-count="pageCountFinished"
                                      :page-range="3"
                                      :margin-pages="2"
                                      :click-handler="getFinishedItems"
                                      :prev-text="'Prev'"
                                      :next-text="'Next'"
                                      :container-class="'mt-2 pagination justify-content-center'"
                                      :page-class="'page-item'"
                                      :page-link-class="'page-link'"
                                      :prev-class="'page-item'"
                                      :prev-link-class="'page-link'"
                                      :next-class="'page-item'"
                                      :next-link-class="'page-link'">
                            </paginate>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import CampaignService from '../services/SmtpCampaignService';
    import MessageService from '../services/MessageService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import {CampaignType, CampaignStatus, RelayStatus} from '../constants';
    import config from '../config';
    import paginateMixin from '../mixins/paginate-mixin';
    import {mapGetters} from 'vuex';
    import Treeselect from '@riophae/vue-treeselect';
    import UserService from '../services/UserService';

    export default {
        name: 'SmtpCampaigns',
        components: {
            Preloader, Breadcrumb, Treeselect
        },
        mixins: [paginateMixin],
        data() {
            return {
                loadingNotFinished: false,
                loadingFinished: false,
                campaignsNotFinished: [],
                campaignsFinished: [],
                totalItemsNotFinished: 0,
                totalItemsFinished: 0,
                pageNotFinished: 1,
                pageFinished: 1,
                perPageNotFinished: 20,
                perPageFinished: 40,
                campaignSearch: {
                    campaignName: null,
                    emailListName: null
                },
                CampaignStatus: CampaignStatus,
                RelayStatus: RelayStatus,
                isAdmin: false,
                userSearch: null,
                userSelect: null,
            }
        },
        mounted() {
            this.isAdmin = this.$store.getters.isAdmin;
            this.getNotFinishedItems(this.page);
            this.getFinishedItems(this.page);
            this.campaignProgress();
        },
        methods: {
            loadUsers({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userSelect = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            search: function () {
                this.getNotFinishedItems(this.pageNotFinished = 1);
                this.getFinishedItems(this.pageFinished = 1);
            },
            getNotFinishedItems: function (pageNum) {
                this.loadingNotFinished = true;
                CampaignService.getNotFinishedCampaigns(pageNum, this.perPageNotFinished, this.campaignSearch, this.userSearch).then(response => {
                    this.campaignsNotFinished = response.data.list;
                    this.totalItemsNotFinished = response.data.totalCount;
                    this.loadingNotFinished = false;
                });
            },
            getFinishedItems: function (pageNum) {
                this.loadingFinished = true;
                CampaignService.getFinishedCampaigns(pageNum, this.perPageFinished, this.campaignSearch, this.userSearch).then(response => {
                    this.campaignsFinished = response.data.list;
                    this.totalItemsFinished = response.data.totalCount;
                    this.loadingFinished = false;
                });
            },
            campaignProgress() {
                if (!this.mercureListen.hasOwnProperty(config.campaignProgressStatus)) {
                    let url = new URL(config.mercureHubUrl);
                    url.searchParams.append('topic', config.campaignProgressStatus);
                    let eventSource = new EventSource(url);
                    this.$store.commit('setListening', {[config.campaignProgressStatus]: eventSource});
                }
                this.mercureListen[config.campaignProgressStatus].onmessage = event => {
                    let data = JSON.parse(event.data);
                    if (data.campaign !== undefined && data.campaign.type === CampaignType.SMTP) {
                        let index = this.campaignsNotFinished.findIndex(obj => obj.id === data.campaign.id);
                        if (typeof (index) === 'number') {
                            this.campaignsNotFinished[index].status = data.campaign.status;
                            this.campaignsNotFinished[index].startDate = data.campaign.startDate;
                        }
                    }
                    if (data.completion !== undefined && data.campaignType === CampaignType.SMTP) {
                        let index = this.campaignsNotFinished.findIndex(obj => obj.id === data.campaignId);
                        if (typeof (index) === 'number') {
                            this.$set(this.campaignsNotFinished[index], 'completion', parseInt(data.completion));
                        }
                    }
                }
            },
            startCampaign(id) {
                let campaign = {
                    id: id,
                    type: CampaignType.SMTP
                };
                let index = this.campaignsNotFinished.findIndex(obj => obj.id === id);
                Swal({
                    title: 'Are you sure you want to start?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        CampaignService.startCampaign(JSON.stringify(campaign)).then(response => {
                            if (response.status >= 400) {
                                Swal(
                                    'Campaign start failed!',
                                    response.data.error.message,
                                    'error'
                                );
                                this.campaignsNotFinished[index].status = CampaignStatus.STATUS_INACTIVE;
                                return false;
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                `Request failed: ${error}`
                            );
                            this.campaignsNotFinished[index].status = CampaignStatus.STATUS_INACTIVE;
                            return false;
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        this.campaignsNotFinished[index].status = this.campaignsNotFinished[index].status === CampaignStatus.STATUS_INACTIVE ? CampaignStatus.STATUS_PREPARING : CampaignStatus.STATUS_ACTIVE;

                        Swal(
                            'Started successfully!',
                            `Campaign has been started.`,
                            'success'
                        );
                    }
                })
            },
            stopCampaign(id) {
                let campaign = {
                    id: id,
                    type: CampaignType.SMTP
                };
                Swal({
                    title: 'Are you sure you want to stop?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        CampaignService.stopCampaign(JSON.stringify(campaign)).then(response => {
                            if (response.status >= 400) {
                                Swal(
                                    'Campaign stop failed!',
                                    response.data.error.message,
                                    'error'
                                );
                                return false;
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                `Request failed: ${error}`
                            );

                            return false;
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Stopped successfully!',
                            `Campaign has been stopped.`,
                            'success'
                        )
                    }
                })
            },
            pauseCampaign(id) {
                let campaign = {
                    id: id,
                    type: CampaignType.SMTP
                };
                Swal({
                    title: 'Are you sure you want to pause?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        CampaignService.pauseCampaign(JSON.stringify(campaign)).then(response => {
                            if (response.status >= 400) {
                                Swal(
                                    'Campaign pause failed!',
                                    response.data.error.message,
                                    'error'
                                );
                                return false;
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                `Request failed: ${error}`
                            );

                            return false;
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Paused successfully!',
                            `Campaign has been paused.`,
                            'success'
                        )
                    }
                })
            },
            startCampaignStatus(campaign) {
                return campaign.status === CampaignStatus.STATUS_INACTIVE || campaign.status === CampaignStatus.STATUS_PAUSED;
            },
            pauseCampaignStatus(campaign) {
                return campaign.status === CampaignStatus.STATUS_ACTIVE || campaign.status === CampaignStatus.STATUS_PREPARING;
            },
            stopCampaignStatus(campaign) {
                return campaign.status !== CampaignStatus.STATUS_FINISHED;
            },
            async openMessage(messageId, campaignId) {
                let message = await MessageService.getMessage(messageId);

                MessageService.getMessagePreview(message.data, campaignId, CampaignType.SMTP).then(response => {
                    if (response.status === 200) {
                        let previewWindow = window.open();
                        previewWindow.document.open();
                        previewWindow.document.write(response.data.html);
                        previewWindow.document.close();
                    }
                });
            }
        },
        computed: {
            pageCountNotFinished: function () {
                return Math.ceil(this.totalItemsNotFinished / this.perPageNotFinished);
            },
            pageCountFinished: function () {
                return Math.ceil(this.totalItemsFinished / this.perPageFinished);
            },
            ...mapGetters({mercureListen: 'listen'})
        }
    }
</script>

<style scoped>
    tbody {
        font-size: 14px;
        font-family: Helvetica, Arial;
    }
</style>